module.exports = __webpack_public_path__ + "img/back-green-img.2142dde0.svg";